export enum OSEnum {
  unknown = 'unknown',
  windows = 'windows',
  mac = 'mac',
  linux = 'linux',
  android = 'android',
  ios = 'ios'
}
